class TagsInput {
    options;
    original_input;
    arr;
    wrapper;
    input;

    constructor(opts) {
        this.options = Object.assign( {
            selector : '',
            wrapperClass : 'tags-input-wrapper',
            tagClass : 'tag',
            answerClass : null,
            groupingClass: '',
            max : null,
            duplicate: false
        } , opts);
        this.original_input = document.getElementById(opts.selector);
        this.arr = [];
        this.wrapper = document.createElement('div');
        this.input = document.createElement('input');
        this.input.classList.add(this.options.inputClass);
        if(opts.groupingClass) {
            this.input.classList.add(opts.groupingClass);
        }
        this.input.setAttribute('placeholder', this.original_input.getAttribute('placeholder'));
        this.input.setAttribute('id', opts.selector);         // to link label after input is replaced
        this.buildUI(this);
        this.addEvents(this);
    }

    addTag = function(str){
        const string = str.startsWith(',') ? str.slice(1, str.length) : str;

        if(this.anyErrors(string) || string == ""){
            return;
        }

        this.arr.push(string);
        var tagInput = this;
   
        var tag = document.createElement('span');
        tag.className = this.options.tagClass;
        tag.innerText = string;

        var closeIcon = document.createElement('button');
        closeIcon.setAttribute('aria-label', `Remove ${string}`)
        closeIcon.innerHTML = '&times;';
        closeIcon.addEventListener('click' , function(e){
            e.preventDefault();
            var tag = this.parentNode;

            for(var i =0 ;i < tagInput.wrapper.childNodes.length ; i++){
                if(tagInput.wrapper.childNodes[i] == tag)
                    tagInput.deleteTag(tag , i);
            }
        })
     
        tag.appendChild(closeIcon);
        this.wrapper.insertBefore(tag , this.input);
        this.original_input.value = this.arr.join(',');

        return this;
    }

    deleteTag = function(tag , i){
        tag.remove();
        this.arr.splice( i , 1);
        this.original_input.value =  this.arr.join(',');

        if(!this.anyErrors(tag.innerText)){
            const errorTag = document.getElementById(`${this.options.selector}c`)
            errorTag.classList.remove('block');
        }

        return this;
    }

    clear = function() {
        this.arr = [];
        this.original_input.value = '';
        Array.from(this.wrapper.querySelectorAll(`.${this.options.tagClass}`))
            .forEach(tagEl => tagEl.remove());
        const err = document.getElementById(`${this.options.selector}c`);
        if (err) err.classList.remove('block');
        return this;
    }

    anyErrors = function(string){
        console.log(`options max: ${this.options.max} , current length: ${this.arr.length}`)
        if( this.options.max != null && this.arr.length >= this.options.max ){
            console.log('max tags limit reached');

            const errorTag = document.getElementById(`${this.options.selector}c`)
            errorTag.classList.add('block');
            return true;
        }
        
        if(!this.options.duplicate && this.arr.indexOf(string) != -1 ){
            console.log('duplicate found " '+string+' " ')
            return true;
        }

        return false;
    }

    getInputString = function(){
        return this.arr.join(';');
    }

    // Private function to initialize the UI Elements
    buildUI(tags){
        tags.wrapper.append(tags.input);
        tags.wrapper.classList.add(tags.options.wrapperClass);
        tags.original_input.setAttribute('hidden' , 'true');
        tags.original_input.removeAttribute('id');
        tags.original_input.parentNode.insertBefore(tags.wrapper , tags.original_input);
    }

    addEvents(tags){
        tags.wrapper.addEventListener('click' ,function(){
            tags.input.focus();           
        });
        tags.input.addEventListener('keydown' , function(e){
            var str = tags.input.value.trim();
            if ([',', 'Enter', 'Tab'].includes(e.key)) {
                tags.input.value = "";
                if(str != "") {
                    tags.addTag(str);
                }
            }
        });
        tags.input.addEventListener('blur' , function(e){
            var str = tags.input.value.trim(); 
                tags.input.value = "";
                if(str != "") {
                    tags.addTag(str);
                }
        });
    }
} 

window.TagsInput = TagsInput;
